import { render, staticRenderFns } from "./TeamBadge.vue?vue&type=template&id=1dd3fbf8&"
import script from "./TeamBadge.vue?vue&type=script&lang=js&"
export * from "./TeamBadge.vue?vue&type=script&lang=js&"
import style0 from "./TeamBadge.vue?vue&type=style&index=0&id=1dd3fbf8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports